import { Serializer } from 'jsonapi-serializer';
import { UpdateVehiclePayload } from '../interfaces/update-vehicle-payload.interface';
import { getVehicleResourceType } from '../utils/vehicle-resource-type.util';

export function serializeVehicle(vehicle: UpdateVehiclePayload) {
	const serializer = new Serializer(getVehicleResourceType(vehicle.model), {
		id: 'id',
		keyForAttribute: (attr: string) => attr,
		pluralizeType: false,
		attributes: ['ats_enabled', 'maas_enabled', 'tracking_enabled'],
	});
	return serializer.serialize(vehicle);
}
